export default __webpack_public_path__ + "static/media/wedding_1.7c93e133.jpg";